import { locationAutocomplete as d, useGlobalStore as p } from "@sunrise/shared";
import { LocationAutocomplete as n } from "@sunrise/types";
import { defineComponent as N, ref as r, computed as s } from "vue";
import g from "./index9.js";
const O = [
  n.LOCATION_LEVELS.LEVEL_CITY,
  n.LOCATION_LEVELS.LEVEL_DISTRICT,
  n.LOCATION_LEVELS.LEVEL_CIRCLE,
  n.LOCATION_LEVELS.LEVEL_STATE,
  n.LOCATION_LEVELS.LEVEL_NATION
], D = N({
  name: "CsLocationAutocomplete",
  components: {
    CsAutocompleteDropdown: g
  },
  props: {
    initialValue: { type: String, default: "" },
    autoFocus: { type: Boolean, default: !1 },
    locationLevels: {
      type: Array,
      default: () => [
        n.LOCATION_LEVELS.LEVEL_STATE,
        n.LOCATION_LEVELS.LEVEL_CIRCLE,
        n.LOCATION_LEVELS.LEVEL_CITY,
        n.LOCATION_LEVELS.LEVEL_DISTRICT,
        n.LOCATION_LEVELS.LEVEL_NATION
      ]
    },
    label: String,
    emptyLabel: String,
    placeholder: String,
    errorMsg: String,
    isInactive: Boolean,
    hasGermanyFallback: Boolean
  },
  emits: ["input", "select", "highlighted"],
  setup(e, { emit: t }) {
    const l = r([]), E = r(e.initialValue), i = r(!1);
    let a = null;
    const T = s(() => e.emptyLabel ? i.value || E.value ? e.label : e.emptyLabel : e.label);
    async function f(o) {
      a == null || a.abort(), E.value = o, t("input", o), !o && e.hasGermanyFallback ? l.value = v() : (a = new AbortController(), l.value = await d.getLocations(
        o,
        e.locationLevels,
        a
      ));
    }
    function V(o) {
      const L = c(o.suggestionItem.text);
      t("select", {
        location: L,
        type: o.type
      });
    }
    function _(o) {
      const L = c(o.text);
      t("highlighted", L);
    }
    function c(o) {
      return l.value.reduce((L, S) => {
        if (Object.keys(L).length > 0)
          return L;
        const u = S.locations.filter((A) => A.name === o);
        return u.length === 1 ? u[0] : L;
      }, {});
    }
    const I = s(
      () => [...l.value].sort(y).map((o) => h(o))
    );
    function m() {
      i.value = !0;
    }
    function C() {
      i.value = !1;
    }
    return {
      hasFocus: i,
      onHighlighted: _,
      onSelect: V,
      onModelUpdate: f,
      suggestions: I,
      modelValue: E,
      onFocus: m,
      onBlur: C,
      computedLabel: T
    };
  }
});
function y(e, t) {
  return O.indexOf(e.type) - O.indexOf(t.type);
}
function h(e) {
  return {
    title: b(e.type),
    items: e.locations.map(
      (t) => ({
        text: t.name,
        label: e.type === n.LOCATION_LEVELS.LEVEL_CITY ? t.titleParent : void 0
      })
    )
  };
}
function b(e) {
  let t = "Vorschläge nach ";
  switch (e) {
    case n.LOCATION_LEVELS.LEVEL_DISTRICT:
      t += "Stadtteil";
      break;
    case n.LOCATION_LEVELS.LEVEL_CIRCLE:
      t += "Stadtkreis";
      break;
    case n.LOCATION_LEVELS.LEVEL_STATE:
      t += "Bundesland";
      break;
    case n.LOCATION_LEVELS.LEVEL_NATION:
      t += "Land";
      break;
    default:
      t += "Stadt";
      break;
  }
  return t;
}
function v() {
  const e = p().requestContext;
  if (!e)
    return [];
  const t = x(e.location);
  return [
    {
      type: n.LOCATION_LEVELS.LEVEL_NATION,
      locations: [k(t)]
    }
  ];
}
function k(e) {
  return {
    id: e.id,
    name: e.name,
    nameShort: e.nameShort,
    titleParent: "",
    locationType: n.LOCATION_LEVELS.LEVEL_NATION
  };
}
function x(e) {
  let t = e;
  for (; t.parent; )
    t = t.parent;
  return t;
}
export {
  D as default
};
